
import {Component} from 'vue-property-decorator';
import {RouterNameEnum} from '@/router/router.types';
import {ServiceNomenclatureStore} from '@/store/modules/ServicesNomenclature';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import ServiceCreateFormComponent from '@/UI/components/forms/serviceCreate/ServiceCreateFormComponent.vue';
import {checkUserRole} from '@/router/Lib/helper';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import {mixins} from 'vue-class-component';
import {SimpleProxyForm} from '@/UI/components/Helpers/SimpleProxyForm';
import {getStudioId} from "@/UI/lib/state";
import ServiceNomenclatureCreateForm from "@/form/service/serviceNomenclatureCreate";
import {FormModel} from "ant-design-vue";

@Component({
  components: {ServiceCreateFormComponent, PageTitle, BaseDataForm},
})
export default class ServicesCreation extends mixins(SimpleProxyForm) {
  form = new ServiceNomenclatureCreateForm();
  formErrors: Record<string, any> = {};

  async created(): Promise<void> {
    try {
      if (this.$route.params.category_id) {
        this.form.category_id = parseInt(this.$route.params.category_id);
      }

      if (checkUserRole() !== 'admin') {
        await this.$router.push({name: this.$routeRules.Services, params: {Studio: "0"}});
      }
      this.formReady = true;
    } catch (e: any) {
      console.log(e);
    }
  }

  setError(property: string, value: string) {
    this.formErrors[property] = value;
  }

  clearError() {
    this.formErrors = {};
  }

  async cancelAction(): Promise<void> {
    if (checkUserRole() === 'owner') {
      await this.$router.push({name: RouterNameEnum.Services, params: {Studio: getStudioId(this)}});
    } else {
      await this.$router.push({name: RouterNameEnum.Services, params: {Studio: "0"}});
    }
  }

  async create(): Promise<void> {
    ((this.$refs.serviceForm as any).$refs.serviceForm as FormModel).validate(async (valid) => {
      const formErrors = Object.keys(this.formErrors);
      if(formErrors.length) {
        for(let i = 0; i < formErrors.length; i++) {
          this.$message.error(this.formErrors[formErrors[i]]);
        }
        valid = false;
      }
      if(valid) {
        if (await this.form.submit(ServiceNomenclatureStore.create)) {
          if (checkUserRole() === 'owner') {
            await this.$router.push({name: RouterNameEnum.Services, params: {Studio: getStudioId(this)}});
          } else {
            await this.$router.push({name: RouterNameEnum.Services, params: {Studio: "0"}});
          }
        }
      }
    });
  }
}
